/**
 * @name DialogProvider
 * @description Global dialog access via React Context
 */

import * as React from "react";
import { useConfirmLogoutDialog } from "~/dialogs/confirm-logout-dialog";
import { useErrorDialog } from "~/dialogs/error-dialog";
import { useFeedbackDialog } from "~/dialogs/feedback-dialog";

export const DialogContext = React.createContext<{
  showError: (error: any) => void;
  setShowErrorDialog: React.Dispatch<React.SetStateAction<boolean>>;
  setShowConfirmLogoutDialog: React.Dispatch<React.SetStateAction<boolean>>;
  setShowFeedbackDialog: React.Dispatch<React.SetStateAction<boolean>>;
}>({
  showError: () => {},
  setShowErrorDialog: () => {},
  setShowConfirmLogoutDialog: () => {},
  setShowFeedbackDialog: () => {},
});

export function DialogProvider({ children }: { children: React.ReactNode }) {
  const { ErrorDialog, showError, setShowErrorDialog } = useErrorDialog();
  const { ConfirmLogoutDialog, setShowConfirmLogoutDialog } =
    useConfirmLogoutDialog();
  const { FeedbackDialog, setShowFeedbackDialog } = useFeedbackDialog();

  return (
    <DialogContext.Provider
      value={{
        showError,
        setShowErrorDialog,
        setShowConfirmLogoutDialog,
        setShowFeedbackDialog,
      }}
    >
      <ErrorDialog />
      <ConfirmLogoutDialog />
      {/* <FeedbackDialog /> */}
      {children}
    </DialogContext.Provider>
  );
}

export const useDialog = () => {
  const contextValue = React.useContext(DialogContext);
  if (!contextValue) {
    throw new Error("useDialog must be used within an DialogProvider");
  }
  return contextValue;
};
